<template>
  <b-list-group-item class="blog-item">
    <b-row class="align-items-center">
      <b-col class="text-truncate">
        <div class="created_at d-flex align-items-center mb-2">
          <span
            v-if="shedule()"
            class="mr-2"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z"
                stroke="#6E747A"
              />
              <path
                d="M7.5 3V8.5H4"
                stroke="#6E747A"
              />
            </svg>

            <b class="ml-2">Scheduled</b> to send
          </span>
          {{ postedDate() | moment("DD/MM/YY [at] h:mm a") }}
        </div>
        <div
          class="blog-label text-truncate mb-0"
          v-text="post.title"
        />
      </b-col>
      <b-col>
        <div class="text-muted font-size-14">
          Category: <span
            class="font-weight-bold"
            v-text="category()"
          />
        </div>
      </b-col>
      <b-col>
        <div
          v-if="post.status_code === 'publish'"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center blog-stat-info mr-4">
            <svg
              class="mr-2"
              width="18"
              height="16"
              viewBox="0 0 18 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.59799 2.36653H14.9431V3.38076H4.59799V2.36653Z"
                fill="#6E747A"
              />
              <path
                d="M4.59799 4.39499H11.2243V5.40922H4.59799V4.39499Z"
                fill="#6E747A"
              />
              <path
                d="M4.59799 6.42345H12.9147V7.43768H4.59799V6.42345Z"
                fill="#6E747A"
              />
              <path
                d="M2.2313 0V3.38076H0V15.66L4.06577 12.4074H12.475V9.80421H13.2437L17.3095 13.0568V0H2.2313ZM11.4608 11.3932H3.70998L1.01423 13.5498V4.39499H2.2313V9.80421H11.4608V11.3932ZM16.2953 10.9466L13.5995 8.78998H3.24553V1.01423H16.2953V10.9466Z"
                fill="#6E747A"
              />
            </svg>

            <span><span class="font-weight-bold">{{ post.comments_count }}</span> Comments (<span
              class="font-weight-bold"
            >{{ post.approved_comments_count }}</span> approved)</span>
          </div>
          <div class="d-flex align-items-center blog-stat-info mr-4">
            <svg
              class="mr-2"
              width="17"
              height="15"
              viewBox="0 0 17 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.6239 8.05226C15.8783 7.76829 16.0333 7.39347 16.0333 6.98337C16.0333 6.09941 15.3139 5.38005 14.4299 5.38005H11.3181C11.6262 4.44477 11.7577 3.2038 11.7577 2.67185V2.13777C11.7577 0.959145 10.7986 0 9.61995 0H9.08551C8.84038 0 8.6266 0.166746 8.5671 0.404751L8.27601 1.56948C7.86805 3.20059 6.57292 5.00024 5.23254 5.32732C4.99774 4.73302 4.41805 4.31116 3.74109 4.31116H0.534442C0.23943 4.31116 0 4.55059 0 4.84561V14.4656C0 14.7606 0.23943 15 0.534442 15H3.74109C4.3785 15 4.93005 14.6262 5.18836 14.0861L7.0247 14.6982C7.62506 14.8985 8.25071 15 8.88385 15H13.361C14.245 15 14.9644 14.2806 14.9644 13.3967C14.9644 13.1882 14.9245 12.9887 14.8518 12.8059C15.5316 12.6203 16.0333 11.9972 16.0333 11.2589C16.0333 10.8488 15.8783 10.474 15.6239 10.19C15.8783 9.90606 16.0333 9.53124 16.0333 9.12114C16.0333 8.71105 15.8783 8.33622 15.6239 8.05226ZM4.27553 13.3967C4.27553 13.6913 4.03575 13.9311 3.74109 13.9311H1.06888V5.38005H3.74109C4.03575 5.38005 4.27553 5.61983 4.27553 5.91449V13.3967ZM13.361 8.5867H14.4299C14.7246 8.5867 14.9644 8.82648 14.9644 9.12114C14.9644 9.4158 14.7246 9.65558 14.4299 9.65558H13.361C13.066 9.65558 12.8266 9.89501 12.8266 10.19C12.8266 10.485 13.066 10.7245 13.361 10.7245H14.4299C14.7246 10.7245 14.9644 10.9643 14.9644 11.2589C14.9644 11.5536 14.7246 11.7933 14.4299 11.7933H13.361C13.066 11.7933 12.8266 12.0328 12.8266 12.3278C12.8266 12.6228 13.066 12.8622 13.361 12.8622C13.6557 12.8622 13.8955 13.102 13.8955 13.3967C13.8955 13.6913 13.6557 13.9311 13.361 13.9311H8.88385C8.36579 13.9311 7.8538 13.8481 7.36247 13.6842L5.34442 13.0115V6.39834C6.18278 6.23907 7.00332 5.7082 7.74406 4.83919C8.46734 3.9905 9.0538 2.86532 9.31283 1.82886L9.50273 1.06888H9.61995C10.2093 1.06888 10.6888 1.54846 10.6888 2.13777V2.67185C10.6888 3.38943 10.4644 4.7658 10.1772 5.38005H9.08551C8.7905 5.38005 8.55107 5.61948 8.55107 5.91449C8.55107 6.2095 8.7905 6.44893 9.08551 6.44893H14.4299C14.7246 6.44893 14.9644 6.68872 14.9644 6.98337C14.9644 7.27803 14.7246 7.51782 14.4299 7.51782H13.361C13.066 7.51782 12.8266 7.75725 12.8266 8.05226C12.8266 8.34727 13.066 8.5867 13.361 8.5867Z"
                fill="#6E747A"
              />
            </svg>
            <span>{{ post.likes_count }} Likes</span>
          </div>
        </div>
        <div
          v-else
          class="text-muted font-size-14 font-weight-bold"
        >
          Not Published
        </div>
      </b-col>
      <b-col>
        <transition name="slide-fade">
          <div
            v-if="showButtons"
            class="d-flex justify-content-end"
          >
            <b-btn
              v-b-tooltip.hover
              variant="link"
              :to="{name: 'blog.manage-comments', params: {post_id: post.id}}"
              title="Manage comments"
            >
              <svg
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.51627 0V3.81253H0V17.66L4.58503 13.992H14.0683V11.0563H14.9351L19.5202 14.7243V0H2.51627ZM12.9245 12.8482H4.1838L1.14376 15.2803V4.95629H2.51627V11.0563H12.9245V12.8482ZM18.3764 12.3446L15.3364 9.91259H3.66003V1.14376H18.3764V12.3446Z"
                  fill="#6E747A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.3309 3.54374C13.4448 3.65764 13.4448 3.84232 13.3309 3.95622L9.83091 7.45622C9.71701 7.57012 9.53234 7.57012 9.41844 7.45622L7.66844 5.70622C7.55453 5.59232 7.55453 5.40764 7.66844 5.29374C7.78234 5.17984 7.96701 5.17984 8.08091 5.29374L9.62467 6.8375L12.9184 3.54374C13.0323 3.42984 13.217 3.42984 13.3309 3.54374Z"
                  fill="#6E747A"
                  stroke="#6E747A"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </b-btn>

            <b-btn
              v-if="post.status_code === 'publish'"
              v-b-tooltip.hover
              variant="link"
              title="View"
              @click="openPost(post)"
            >
              <svg
                class="ml-1"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.5237 8.47009C17.4877 8.42419 16.6238 7.33313 15.1427 6.23768C13.1635 4.77378 11.01 4 8.91494 4C6.81997 4 4.66645 4.77378 2.68722 6.23768C1.20615 7.33309 0.34224 8.42419 0.306213 8.47009L0 8.85998L0.306252 9.24992C0.342279 9.29581 1.20619 10.3869 2.68725 11.4824C4.66649 12.9462 6.82001 13.72 8.91498 13.72C11.01 13.72 13.1635 12.9462 15.1427 11.4824C16.6238 10.3869 17.4877 9.29581 17.5237 9.24992L17.83 8.85998L17.5237 8.47009ZM8.91493 12.2646C7.05018 12.2646 5.53305 10.7373 5.53305 8.85995C5.53305 8.56582 5.57029 8.28029 5.64027 8.00786L4.86817 7.87704C4.79252 8.19239 4.75239 8.52153 4.75239 8.85995C4.75239 10.0726 5.26693 11.1665 6.08747 11.9324C5.03121 11.5396 4.13302 10.9884 3.45514 10.4899C2.61531 9.87234 1.9859 9.24776 1.62708 8.85995C1.98606 8.47202 2.61539 7.84753 3.45514 7.23003C4.13302 6.73152 5.03125 6.18031 6.08747 5.78747L6.60544 6.37526C7.21037 5.805 8.0228 5.45526 8.91493 5.45526C10.7797 5.45526 12.2968 6.98258 12.2968 8.85995C12.2968 10.7373 10.7797 12.2646 8.91493 12.2646ZM11.7424 11.9324C12.7986 11.5396 13.6968 10.9884 14.3747 10.4899C15.2145 9.87246 15.8438 9.24793 16.2028 8.85992C15.844 8.47215 15.2146 7.84757 14.3747 7.23004C13.6968 6.73153 12.7987 6.18032 11.7424 5.78748C12.5629 6.5534 13.0774 7.6472 13.0774 8.85996C13.0774 10.0727 12.5629 11.1666 11.7424 11.9324Z"
                  fill="#6E747A"
                />
                <path
                  d="M6.46941 7.81629C6.40355 8.03262 6.36786 8.2621 6.36786 8.50003C6.36786 9.79235 7.41322 10.84 8.70276 10.84C9.99226 10.84 11.0376 9.79239 11.0376 8.50003C11.0376 7.20768 9.99226 6.16003 8.70276 6.16003C8.07466 6.16003 7.50493 6.40905 7.08524 6.81338L8.23693 8.11438L6.46941 7.81629Z"
                  fill="#6E747A"
                />
              </svg>
            </b-btn>

            <b-btn
              v-b-tooltip.hover
              variant="link"
              title="Edit"
              @click="edit"
            >
              <svg
                class="ml-1"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M14.1427 9.00002C13.8271 9.00002 13.5712 9.25585 13.5712 9.57145V15.2856C13.5712 15.6012 13.3154 15.8571 12.9998 15.8571H2.71426C2.39866 15.8571 2.14283 15.6012 2.14283 15.2856V3.85723C2.14283 3.54163 2.39866 3.2858 2.71426 3.2858H9.57131C9.88691 3.2858 10.1427 3.02996 10.1427 2.71437C10.1427 2.39877 9.88691 2.14297 9.57131 2.14297H2.71426C1.7675 2.14297 1 2.91047 1 3.85723V15.2856C1 16.2324 1.7675 16.9999 2.71426 16.9999H12.9998C13.9466 16.9999 14.7141 16.2324 14.7141 15.2856V9.57142C14.7141 9.25585 14.4583 9.00002 14.1427 9.00002Z"
                    fill="#6E747A"
                  />
                  <path
                    d="M16.3595 1.64091C15.9492 1.23056 15.3927 1.00007 14.8124 1.00014C14.2318 0.998465 13.6748 1.22935 13.2656 1.64128L5.73882 9.16743C5.67638 9.23034 5.62927 9.30681 5.60111 9.39085L4.45828 12.8194C4.35853 13.1188 4.52042 13.4424 4.81985 13.5421C4.87794 13.5614 4.93877 13.5713 4.99998 13.5714C5.06132 13.5713 5.12229 13.5614 5.18054 13.5422L8.60907 12.3994C8.69328 12.3713 8.76979 12.324 8.8325 12.2611L16.3593 4.73439C17.2135 3.8802 17.2136 2.4952 16.3595 1.64091ZM15.5513 3.92694L8.12279 11.3554L5.90338 12.0965L6.64222 9.87999L14.0736 2.45154C14.4821 2.0438 15.1439 2.04447 15.5516 2.45301C15.7464 2.64817 15.8561 2.91238 15.857 3.1881C15.8577 3.4653 15.7476 3.73127 15.5513 3.92694Z"
                    fill="#6E747A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(1 1)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </b-btn>

            <delete-confirm
              title="Are you sure?"
              description="The post will be deleted, the action cannot be undone."
              @confirm="deletePost"
            >
              <template #activator="{on}">
                <b-btn
                  v-b-tooltip.hover
                  variant="link"
                  title="Delete"
                  v-on="on"
                >
                  <svg
                    class="ml-1"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.6395 6.03585L10.3712 5.98781L10.0962 13.7429L11.3645 13.7907L11.6395 6.03585Z"
                      fill="#6E747A"
                    />
                    <path
                      d="M9.18616 6.01183H7.91699V13.7669H9.18616V6.01183Z"
                      fill="#6E747A"
                    />
                    <path
                      d="M7.00676 13.7427L6.73178 5.98759L5.46344 6.03567L5.73845 13.7907L7.00676 13.7427Z"
                      fill="#6E747A"
                    />
                    <path
                      d="M1 2.77875V4.08945H2.32249L3.37165 16.4021C3.40041 16.7405 3.67479 17 4.0037 17H13.0781C13.4071 17 13.6816 16.7403 13.7102 16.4019L14.7594 4.08945H16.1032V2.77875H1ZM12.4969 15.6893H4.5848L3.59653 4.08945H13.4853L12.4969 15.6893Z"
                      fill="#6E747A"
                    />
                    <path
                      d="M10.9443 0H6.84654C6.27014 0 5.80121 0.53181 5.80121 1.1855V3.438H7.0556V1.42261H10.7352V3.438H11.9896V1.1855C11.9896 0.53181 11.5207 0 10.9443 0Z"
                      fill="#6E747A"
                    />
                  </svg>
                </b-btn>
              </template>
            </delete-confirm>
          </div>
        </transition>
      </b-col>
    </b-row>

    <!--                <div class="d-flex align-items-center justify-content-between">-->
    <!--                  <b-btn :href="`${getPageBlankURL}/blog/${post.slug}`" target="_blank">-->
    <!--                    View <i class="fa fa-external-link-alt fa-sm ml-1"></i>-->
    <!--                  </b-btn>-->

    <!--                  <div>-->
    <!--                    <b-btn class="mr-2" @click="edit(post)">-->
    <!--                      Edit <i class="fa fa-edit fa-sm ml-1"></i>-->
    <!--                    </b-btn>-->
    <!--                    <b-btn variant="danger" @click="deletePost(post, index)">-->
    <!--                      Delete <i class="fa fa-trash fa-sm ml-1"></i>-->
    <!--                    </b-btn>-->
    <!--                  </div>-->
    <!--                </div>-->
  </b-list-group-item>
</template>

<script>
import _ from 'lodash'
import RouterMixin from '../../../components/mixins/RouterMixin'
import DeleteConfirm from '../../../components/editor/modals/DeleteConfirm'
import moment from 'moment-timezone'

export default {
  name: 'EsBlogListItem',
  components: {DeleteConfirm},
  mixins: [RouterMixin],
  props: {
    post: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      showButtons: true
    }
  },
  methods: {
    category () {
      return _.get(_.head(this.post.categories), 'name') || 'No Category'
    },
    shedule () {
      return this.postedDate().isAfter(moment())
    },
    postedDate () {
      return moment.tz(this.post.post_date, 'Europe/London').tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
    },
    edit () {
      // VEvent.fire('blog.post-edit', this.post)
      this.$store.dispatch('blogEditor/startEdit', this.post)
    },
    openPost (post) {
      return window.open(`${this.getSiteHome}/blog/${post.slug}`, '_blank')
    },
    deletePost () {
      this.$store.dispatch('blogEditor/postDelete', this.post)
        .then(() => {
          this.$emit('deleted')
          this.$swal({
            icon: 'success',
            title: 'Post Deleted',
            showConfirmButton: false,
            timer: 1500
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@builder/assets/scss/_variables.scss";

.created_at {
  color: #888d92;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 1px;
}

.blog-label {
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #333333;
  transition: .3s;
}

.blog-item {
  border-color: #E2E5EC;
  padding: 28px 40px;
  transition: .3s;

  &:hover {
    background: #FAFCFF;

    .blog-label {
      color: $primary;
    }
  }

  .blog-stat-info {
    color: #6E747A;

    svg path {
      fill: #6E747A;
    }

    &.disabled {
      color: #D1D2D3;

      svg path {
        fill: #D1D2D3;
      }
    }
  }
}
</style>
